import { Branches } from "@/@types/Branches";
import { GetBranchesResponse } from "@/services/api/branches/schema/GetBranchesResponse";
import { ApiClient } from "../../ApiClient";
import { mapBranches } from "../../mappers/branches/branchesMapper";

export const getBranches = async (): Promise<Branches[]> => {

    const client = ApiClient.getInstance()
    const response = await client.get<GetBranchesResponse>("branches/offices")

    return response.data.map(mapBranches)

}